import React, { Component } from "react";
import PropTypes from "prop-types";
import { Utils } from "arv-reactcomponents";

import BrandsListKeyComponent from "../BrandsListKeyComponent";

class BrandsListKeyContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFixedClass: false,
    };

    this.handleFixedKeyContainer = this.handleFixedKeyContainer.bind(this);
    this.goToBrandBlock = this.goToBrandBlock.bind(this);
    this.setContext = this.setContext.bind(this);
  }

  componentDidMount() {
    Utils.onElementScroll(window, () => {
      const windowValues = Utils.windowScroll();

      this.handleFixedKeyContainer(windowValues);
    });
  }

  get isFixedClassName() {
    const { isFixedClass } = this.state;
    const fixedClassName = this.isWrapperShort ? "is-topfixed" : "is-fixed";
    return isFixedClass ? fixedClassName : "";
  }

  setContext(ref) {
    const { height: wrapperHeight } = Utils.getBoundClientRect(ref);
    const { outerHeight } = window;

    this.wrapperRef = ref;
    this.wrapperVals = Utils.getBoundClientRect(this.wrapperRef);
    this.isWrapperShort = wrapperHeight <= outerHeight;
  }

  handleFixedKeyContainer(windowValues) {
    const { top, bottom } = windowValues;
    const { top: wrapperTop, bottom: wrapperBottom } = this.wrapperVals;
    const shouldFix = this.isWrapperShort
      ? top >= wrapperTop
      : bottom >= wrapperBottom;

    if (shouldFix) {
      this.setState({
        isFixedClass: true,
      });
    } else {
      this.setState({
        isFixedClass: false,
      });
    }
  }

  goToBrandBlock(value) {
    this.props.brandBlockFn(value);
  }

  render() {
    const { brandsListKeys, className } = this.props;
    return (
      <div
        ref={this.setContext}
        className={`${className} ${this.isFixedClassName}`}
      >
        {brandsListKeys && brandsListKeys.length
          ? brandsListKeys.map(brand => (
              <BrandsListKeyComponent.component
                key={brand}
                brandKey={brand}
                brandBlock={this.goToBrandBlock}
              />
            ))
          : null}
      </div>
    );
  }
}

BrandsListKeyContainer.propTypes = {
  className: PropTypes.string.isRequired,
  brandsListKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  brandBlockFn: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandsListKeyContainer,
  component: BrandsListKeyContainer,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BrandsListKeyContainer/index.js